import {resetAmplitude} from 'analytics/amplitude';
import {redirectToTimeout, setURLParams} from 'BenchlingUtil';
import {submitCSRFForm} from 'util/Net';

/**
 * Client-side sign-out teardown, then POST /signout. Optionally redirect to a next URL.
 */
export function signOut(next?: string): void {
  resetAmplitude();
  const action = next != null ? setURLParams('/signout', {next}) : '/signout';
  submitCSRFForm('POST', action);
}

/**
 * Client-side sign-out teardown, then navigate to the session-expired page.
 * Call before leaving the authenticated app so in-memory client state can be cleared.
 */
export function redirectToSessionExpired(): void {
  resetAmplitude();
  redirectToTimeout();
}
